import React, { useState } from 'react'
import LeadError from '../LeadError'
import Radio from 'app/theme/forms/Radio'
import { Spinner } from 'app/theme/Spinner'

const resetHighestLandedStep = (steps, step, setHighestLandedStep) => {
  setHighestLandedStep(steps.findIndex(s => s === step))
}

export default function LeadCateringOccasion(props) {
  const { occasions, occasionsIsLoading, data, setData, errors, setErrors, setHighestLandedStep, step, steps } = props
  const [displayWedding, setDisplayWedding] = useState(false)

  const occasionId = data.occasion?.id

  return (
    <div>
      <div className="font-light">
        {occasionsIsLoading ? (
          <div className="">
            <Spinner className="text-blue w-10 h-10 mx-auto my-5"/>
          </div>
        ) : occasions.length ? (
            <BusinessAndPersonalOccasions {...props} occasionId={occasionId} />
        ) : (
          <div className="font-bold px-8 py-3 text-center text-red-600">
            An unexpected error occurred. Please try to submit your details again in a few minutes.
          </div>
        )}
      </div>
    </div>
  )
}

function BusinessAndPersonalOccasions({occasionId, occasions, ...props}) {
  const { setData, errors, setErrors, setHighestLandedStep, step, steps } = props
  
  const OCCASION_CODES = ['business', 'personal']
  
  const occasionsBusinessAndPersonal = occasions.filter(({code}) => OCCASION_CODES.includes(code)).sort((a, b) => {
    if (a.name < b.name) return -1
    else if (a.name > b.name) return 1
    else return 0
  })

  return (
    <>
      {occasionsBusinessAndPersonal.map((occasion) => (
        <div
          key={occasion.id}
          className={[
            'px-8 py-3',
            'border-b border-gray-300',
          ].join(' ')}
        >
          <Radio
            name="occasion"
            label={occasion.name}
            checked={occasionId === occasion.id}
            onChange={_ => {
              setErrors(false)
              setData(prev => ({
                ...prev,
                occasion,
              }))
              if (occasion.code === 'business') {
                resetHighestLandedStep(steps, step, setHighestLandedStep)
              }
            }}
          />
        </div>
      ))}
      {errors?.occasion && (
        <div className="font-bold px-8 py-3 border-t border-gray-300">
          <LeadError
            message={errors.occasion}
          />
        </div>
      )}
    </>
  )
}